const p=(p=[])=>p.find(p=>["pickup_point","store_pickup"].includes(p.type));export{p as default};
